import { render, staticRenderFns } from "./MappingRuleModal.vue?vue&type=template&id=5598bcf4&scoped=true"
import script from "./MappingRuleModal.vue?vue&type=script&lang=js"
export * from "./MappingRuleModal.vue?vue&type=script&lang=js"
import style0 from "./MappingRuleModal.vue?vue&type=style&index=0&id=5598bcf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598bcf4",
  null
  
)

export default component.exports